import React, { useMemo } from 'react';
import { useGetBookQuery } from '@/api/types';
import { Icon, BookMedia } from '@/components';

interface ManageDecodableBookPodProps {
  bookId: string;
}

export const ManageDecodableBookPod = ({
  bookId,
}: ManageDecodableBookPodProps) => {
  const { data: bookResult, loading: bookLoading } = useGetBookQuery({
    variables: {
      id: bookId,
    },
  });

  const book = useMemo(
    () =>
      bookResult?.book.__typename === 'StudioLibraryBook'
        ? bookResult.book
        : undefined,
    [bookResult],
  );

  if (bookLoading) {
    return (
      <div className="rounded-[14px] border border-pt-ds-line bg-pt-cream p-3.5">
        <div className="mb-2.5 h-4 w-2/3 animate-pulse rounded bg-pt-silver/30" />
        <div className="mb-2.5 h-[120px] animate-pulse rounded-[10px] bg-pt-silver/30" />
        <div className="h-9 animate-pulse rounded-lg bg-pt-silver/30" />
      </div>
    );
  }

  if (!book) {
    return (
      <div className="rounded-[14px] border border-pt-ds-line bg-pt-cream p-3.5 text-center">
        <div className="mb-2.5 grid h-[120px] place-items-center rounded-[10px] bg-pt-ds-line/60">
          <Icon name="openBook" size={40} className="text-pt-ds-muted" />
        </div>
        <div className="font-inter text-xs font-semibold text-pt-ds-muted">
          Book unavailable
        </div>
      </div>
    );
  }

  return (
    <div className="rounded-[14px] border border-pt-ds-line bg-pt-cream p-3.5 text-center">
      <div className="mb-2.5 font-display text-base font-bold text-pt-ds-ink">
        {book.title}
      </div>

      <div className="mb-2.5 overflow-hidden rounded-[10px]">
        {book.coverURL ? (
          <BookMedia bookCover={book.coverURL} altText={book.title || ''} />
        ) : (
          <div className="grid h-[120px] place-items-center rounded-[10px] bg-pt-ds-line/60">
            <Icon name="openBook" size={40} className="text-pt-ds-muted" />
          </div>
        )}
      </div>

      <div className="mb-1 font-display text-[13px] font-extrabold text-pt-primary">
        Phonics
      </div>

      <a
        href={`/read/${book.id}`}
        className="block w-full rounded-lg bg-pt-bottle-green py-2.5 font-inter text-[13px] font-semibold text-white no-underline hover:opacity-90"
      >
        Open book
      </a>
    </div>
  );
};
